import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { 
    ReservationCreate,
    ReservationList,
    ReservationDetail
} from '../../_models/reservation.model';
import { ApiResponse } from '../../_models/api-response.model';

@Injectable({
    providedIn: 'root'
})
export class ReservationService {
    private userApiUrl = `${environment.apiUrl}/reservations`;

    constructor(private http: HttpClient) { }

    createReservation(reservationCreate: ReservationCreate): Observable<ApiResponse<ReservationDetail>> {
        return this.http.post<ApiResponse<ReservationDetail>>(this.userApiUrl, reservationCreate);
    }

    getMyReservations(
        search?: string,
        startDateFrom?: string,
        startDateTo?: string
    ): Observable<ApiResponse<ReservationList[]>> {
        let params = new HttpParams();
        
        if (search) {
            params = params.set('search', search);
        }
        if (startDateFrom) {
            params = params.set('startDateFrom', startDateFrom);
        }
        if (startDateTo) {
            params = params.set('startDateTo', startDateTo);
        }

        return this.http.get<ApiResponse<ReservationList[]>>(`${this.userApiUrl}/my-reservations`, { params });
    }

    getReservationDetails(reservationId: number): Observable<ApiResponse<ReservationDetail>> {
        return this.http.get<ApiResponse<ReservationDetail>>(`${this.userApiUrl}/${reservationId}`);
    }
}